import {
  FileTextIcon,
  ZapIcon,
  ActivityIcon,
  SmartphoneIcon,
  ShieldCheckIcon,
  LockIcon,
  CreditCardIcon,
} from 'lucide-react';

export const heroChips = [
  { icon: FileTextIcon, label: '100% PDF' },
  { icon: ZapIcon, label: 'Sofort-Download' },
  { icon: ActivityIcon, label: 'Alle Level (Anfänger & Profi)' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const heroTrust = [
  { icon: ShieldCheckIcon, label: '7-Tage-Garantie' },
  { icon: LockIcon, label: 'Sichere Zahlung' },
  { icon: CreditCardIcon, label: 'Kreditkarte / Lastschrift' },
  { icon: ZapIcon, label: 'Sofortiger Zugriff' },
];

export const stats = [
  { value: '500+', label: 'Zufriedene Profis ⭐' },
  { value: '6', label: 'Komplette Bände' },
  { value: '5', label: 'Inklusive Boni' },
  { value: '4.9/5', label: 'Bewertung' },
];
